import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=a6f88a4c&scoped=true"
import script from "./Subtitle.vue?vue&type=script&lang=js"
export * from "./Subtitle.vue?vue&type=script&lang=js"
import style0 from "./Subtitle.vue?vue&type=style&index=0&id=a6f88a4c&prod&lang=css"
import style1 from "./Subtitle.vue?vue&type=style&index=1&id=a6f88a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f88a4c",
  null
  
)

export default component.exports